import axios from "axios";
import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";

const BlogParent = () => {
  const [posts, setPosts] = useState([]);
  const [loading, isLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    // Fetch all blog posts once
    const fetchBlogs = async () => {
      try {
        const response = await axios.get("/blog.json");

        setPosts(response.data);
        isLoading(false);
      } catch (error) {
        console.error("Error fetching blogs:", error);
        navigate("/notfound");
      }
    };

    fetchBlogs();
  }, [navigate]);

  return <Outlet context={{ posts, loading }} />;
};

export default BlogParent;
